<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.08 8a1 1 0 00-1.08.92L16.08 20H7.92L7 8.92a1 1 0 10-2 .16l1 12A1 1 0 007 22h10a1 1 0 001-.92l1-12A1 1 0 0018.08 8zM19 5h-3.77l-.65-2.27a1 1 0 00-1-.73h-3.2a1 1 0 00-1 .73L8.77 5H5a1 1 0 000 2h14a1 1 0 000-2zm-8.62-2h3.24l.57 2H9.81z"/><path d="M12.5 18v-8a.5.5 0 00-1 0v8a.5.5 0 001 0zM14.25 18.5a.5.5 0 00.5-.47l.5-8a.5.5 0 00-.47-.53.49.49 0 00-.53.47l-.5 8a.5.5 0 00.47.53zM9.75 18.5a.5.5 0 00.47-.53l-.5-8a.49.49 0 00-.53-.47.5.5 0 00-.47.53l.5 8a.5.5 0 00.53.47z"/></svg>